// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"46":"splide","125":"accordian"}[chunkId] || chunkId) + "." + {"46":"0b8871c38daa","125":"1fcc59dddf3e","846":"ed6f58e59a07"}[chunkId] + ".bundle.js";
};